"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachmentDataUrl = useAttachmentDataUrl;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useAttachmentClient_1 = require("./useAttachmentClient");
/**
 * Generates attachment's data URL and returns an SWR response.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param entityId - entity id, this is optional, if not set backend will not be called and result will not be returned
 * @param key - attachment key, this is optional, if not set backend will not be called and result will not be returned
 * @param version - attachment version, this is optional
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object
 */
function useAttachmentDataUrl(entity, entityId, key, version, baseUrl, tokenProvider, config) {
    const attachmentClient = (0, useAttachmentClient_1.useAttachmentClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)(entityId && key ? ['/platform/api/v1/attachment/get', entity, entityId, key, version] : null, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async ([_, entity, entityId, key, version]) => {
        return entityId && key ? (0, utils_1.getImageDataUrl)(attachmentClient, entity, entityId, key, version) : undefined;
    }, config ?? {
        revalidateOnFocus: false,
    });
}
